import { styled } from 'styled-components';

export const StyledTH = styled.th`
  color: white !important;
  text-align: center !important;
`;

export const StyledRow = styled.div`
  margin-right: -15px;
  margin-left: -15px;
`;

export const StyledTableWrapper = styled.div`
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  td,
  th {
    padding: 0;
  }

  table {
    background-color: transparent;
  }

  th {
    text-align: left;
  }

  .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }

  .table > thead > tr > th,
  .table > tbody > tr > th,
  .table > tfoot > tr > th,
  .table > thead > tr > td,
  .table > tbody > tr > td,
  .table > tfoot > tr > td {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
  }

  .table > thead > tr > th {
    vertical-align: bottom;
    border-bottom: 2px solid #ddd;
  }

  .table > caption + thead > tr:first-child > th,
  .table > colgroup + thead > tr:first-child > th,
  .table > thead:first-child > tr:first-child > th,
  .table > caption + thead > tr:first-child > td,
  .table > colgroup + thead > tr:first-child > td,
  .table > thead:first-child > tr:first-child > td {
    border-top: 0;
  }

  .table > tbody + tbody {
    border-top: 2px solid #ddd;
  }

  .table .table {
    background-color: #fff;
  }

  .table-condensed > thead > tr > th,
  .table-condensed > tbody > tr > th,
  .table-condensed > tfoot > tr > th,
  .table-condensed > thead > tr > td,
  .table-condensed > tbody > tr > td,
  .table-condensed > tfoot > tr > td {
    padding: 5px;
  }

  table col[class*='col-'] {
    position: static;
    display: table-column;
    float: none;
  }

  table td[class*='col-'],
  table th[class*='col-'] {
    position: static;
    display: table-cell;
    float: none;
  }

  .table > thead > tr > td.active,
  .table > tbody > tr > td.active,
  .table > tfoot > tr > td.active,
  .table > thead > tr > th.active,
  .table > tbody > tr > th.active,
  .table > tfoot > tr > th.active,
  .table > thead > tr.active > td,
  .table > tbody > tr.active > td,
  .table > tfoot > tr.active > td,
  .table > thead > tr.active > th,
  .table > tbody > tr.active > th,
  .table > tfoot > tr.active > th {
    background-color: #f5f5f5;
  }

  .table > thead > tr > td.success,
  .table > tbody > tr > td.success,
  .table > tfoot > tr > td.success,
  .table > thead > tr > th.success,
  .table > tbody > tr > th.success,
  .table > tfoot > tr > th.success,
  .table > thead > tr.success > td,
  .table > tbody > tr.success > td,
  .table > tfoot > tr.success > td,
  .table > thead > tr.success > th,
  .table > tbody > tr.success > th,
  .table > tfoot > tr.success > th {
    background-color: #dff0d8;
  }

  .table > thead > tr > td.info,
  .table > tbody > tr > td.info,
  .table > tfoot > tr > td.info,
  .table > thead > tr > th.info,
  .table > tbody > tr > th.info,
  .table > tfoot > tr > th.info,
  .table > thead > tr.info > td,
  .table > tbody > tr.info > td,
  .table > tfoot > tr.info > td,
  .table > thead > tr.info > th,
  .table > tbody > tr.info > th,
  .table > tfoot > tr.info > th {
    background-color: #d9edf7;
  }

  .table > thead > tr > td.warning,
  .table > tbody > tr > td.warning,
  .table > tfoot > tr > td.warning,
  .table > thead > tr > th.warning,
  .table > tbody > tr > th.warning,
  .table > tfoot > tr > th.warning,
  .table > thead > tr.warning > td,
  .table > tbody > tr.warning > td,
  .table > tfoot > tr.warning > td,
  .table > thead > tr.warning > th,
  .table > tbody > tr.warning > th,
  .table > tfoot > tr.warning > th {
    background-color: #fcf8e3;
  }

  .table > thead > tr > td.danger,
  .table > tbody > tr > td.danger,
  .table > tfoot > tr > td.danger,
  .table > thead > tr > th.danger,
  .table > tbody > tr > th.danger,
  .table > tfoot > tr > th.danger,
  .table > thead > tr.danger > td,
  .table > tbody > tr.danger > td,
  .table > tfoot > tr.danger > td,
  .table > thead > tr.danger > th,
  .table > tbody > tr.danger > th,
  .table > tfoot > tr.danger > th {
    background-color: #f2dede;
  }

  .table-responsive {
    min-height: 0.01%;
    overflow-x: auto;
  }

  @media screen and (max-width: 767px) {
    .table-responsive {
      width: 100%;
      margin-bottom: 15px;
      overflow-y: hidden;
      border: 1px solid #ddd;
      -ms-overflow-style: -ms-autohiding-scrollbar;
    }

    .table-responsive > .table {
      margin-bottom: 0;
    }

    .table-responsive > .table > thead > tr > th,
    .table-responsive > .table > tbody > tr > th,
    .table-responsive > .table > tfoot > tr > th,
    .table-responsive > .table > thead > tr > td,
    .table-responsive > .table > tbody > tr > td,
    .table-responsive > .table > tfoot > tr > td {
      white-space: nowrap;
    }
  }

  .table > thead > tr > td.primary,
  .table > tbody > tr > td.primary,
  .table > tfoot > tr > td.primary,
  .table > thead > tr > th.primary,
  .table > tbody > tr > th.primary,
  .table > tfoot > tr > th.primary,
  .table > thead > tr.primary > td,
  .table > tbody > tr.primary > td,
  .table > tfoot > tr.primary > td,
  .table > thead > tr.primary > th,
  .table > tbody > tr.primary > th,
  .table > tfoot > tr.primary > th {
    background-color: rgba(126, 87, 194, 0.2);
  }

  .table > thead > tr > td.accent,
  .table > tbody > tr > td.accent,
  .table > tfoot > tr > td.accent,
  .table > thead > tr > th.accent,
  .table > tbody > tr > th.accent,
  .table > tfoot > tr > th.accent,
  .table > thead > tr.accent > td,
  .table > tbody > tr.accent > td,
  .table > tfoot > tr.accent > td,
  .table > thead > tr.accent > th,
  .table > tbody > tr.accent > th,
  .table > tfoot > tr.accent > th {
    background-color: rgba(255, 152, 0, 0.2);
  }

  .table > thead > tr > td.secondary,
  .table > tbody > tr > td.secondary,
  .table > tfoot > tr > td.secondary,
  .table > thead > tr > th.secondary,
  .table > tbody > tr > th.secondary,
  .table > tfoot > tr > th.secondary,
  .table > thead > tr.secondary > td,
  .table > tbody > tr.secondary > td,
  .table > tfoot > tr.secondary > td,
  .table > thead > tr.secondary > th,
  .table > tbody > tr.secondary > th,
  .table > tfoot > tr.secondary > th {
    background-color: #9e9e9e;
  }

  .table > tbody > tr.warning > td,
  .table > tbody > tr.warning > th,
  .table > tbody > tr > td.warning,
  .table > tbody > tr > th.warning,
  .table > tfoot > tr.warning > td,
  .table > tfoot > tr.warning > th,
  .table > tfoot > tr > td.warning,
  .table > tfoot > tr > th.warning,
  .table > thead > tr.warning > td,
  .table > thead > tr.warning > th,
  .table > thead > tr > td.warning,
  .table > thead > tr > th.warning {
    background-color: rgba(253, 216, 53, 0.2);
  }

  .table > tbody > tr.danger > td,
  .table > tbody > tr.danger > th,
  .table > tbody > tr > td.danger,
  .table > tbody > tr > th.danger,
  .table > tfoot > tr.danger > td,
  .table > tfoot > tr.danger > th,
  .table > tfoot > tr > td.danger,
  .table > tfoot > tr > th.danger,
  .table > thead > tr.danger > td,
  .table > thead > tr.danger > th,
  .table > thead > tr > td.danger,
  .table > thead > tr > th.danger {
    background-color: rgba(244, 67, 54, 0.2);
  }

  .table > tbody > tr.success > td,
  .table > tbody > tr.success > th,
  .table > tbody > tr > td.success,
  .table > tbody > tr > th.success,
  .table > tfoot > tr.success > td,
  .table > tfoot > tr.success > th,
  .table > tfoot > tr > td.success,
  .table > tfoot > tr > th.success,
  .table > thead > tr.success > td,
  .table > thead > tr.success > th,
  .table > thead > tr > td.success,
  .table > thead > tr > th.success {
    background-color: rgba(76, 175, 80, 0.2);
  }

  .table > tbody > tr.info > td,
  .table > tbody > tr.info > th,
  .table > tbody > tr > td.info,
  .table > tbody > tr > th.info,
  .table > tfoot > tr.info > td,
  .table > tfoot > tr.info > th,
  .table > tfoot > tr > td.info,
  .table > tfoot > tr > th.info,
  .table > thead > tr.info > td,
  .table > thead > tr.info > th,
  .table > thead > tr > td.info,
  .table > thead > tr > th.info {
    background-color: rgba(0, 176, 255, 0.2);
  }

  .table > thead > tr > th,
  .table > tbody > tr > th,
  .table > tfoot > tr > th,
  .table > thead > tr > td,
  .table > tbody > tr > td,
  .table > tfoot > tr > td {
    padding: 12px 15px 11px 15px;
    border-color: #e0e0e0;
  }

  .table > thead > tr > th,
  .table > tbody > tr > th,
  .table > tfoot > tr > th {
    font-weight: 600;
    color: #424242;
  }

  .table.table-condensed > thead > tr > th,
  .table.table-condensed > tbody > tr > th,
  .table.table-condensed > tfoot > tr > th,
  .table.table-condensed > thead > tr > td,
  .table.table-condensed > tbody > tr > td,
  .table.table-condensed > tfoot > tr > td {
    padding: 5px;
  }

  .table.invoice-table > tbody > tr > .no-line {
    border-top: 0;
  }

  .table.invoice-table > thead > tr > .no-line {
    border-bottom: 0;
  }

  .table.invoice-table > tbody > tr > .thick-line {
    border-top: 1px solid #aaa;
  }

  .table.invoice-table > thead > tr {
    color: #757575;
    background-color: #f5f5f5;
  }

  .table.invoice-table > thead > tr td {
    padding: 10px;
  }

  .table.invoice-table .thick-line h4,
  .table.invoice-table .thick-line h3,
  .table.invoice-table .no-line h4,
  .table.invoice-table .no-line h3 {
    margin: 0;
  }

  .table.invoice-table > thead > tr > td > h4 {
    margin: 0;
    color: #757575;
  }

  .custom-itinerary-table > thead > tr > td,
  .custom-itinerary-table > tbody > tr > td,
  .custom-itinerary-table > tfoot > tr > td {
    padding: 0px 10px 0px 10px;
    border-color: #e0e0e0;
    vertical-align: middle;
  }

  .custom-itinerary-table > tbody > tr:nth-child(odd) > td {
    background-color: rgba(0, 0, 0, 0.075);
  }

  .custom-itinerary-table > tbody > tr:hover > td {
    background-color: antiquewhite;
    cursor: move;
  }

  .custom-itinerary-table > thead > tr > th,
  .custom-itinerary-table > tbody > tr > th,
  .custom-itinerary-table > tfoot > tr > th {
    padding: 10px 10px 10px 10px;
  }

  .custom-itinerary-table {
    border-color: grey;
    margin-top: 5px !important;
  }
`;
